import React from 'react'

import { Form, Select, DatePicker, Input } from 'antd'
import moment from 'moment'
import Icon from 'react-fontawesome'
import data from './data'

const Option = Select.Option


class TransformEditor extends React.Component {

  constructor(props, ...args) {
    super(props, ...args)
    const { id } = props.match.params
    const record = data.find(x => x.key === id) || {}
    this.state = {
      sourceField: record.sourceField || '',
      sourceDataType: record.sourceDataType || '',
      sourceDataFormat: record.sourceDataFormat || '',
      targetField: record.targetField || '',
      targetDataFormat: record.targetDataFormat || '',
      sampleInput: record.sampleInput || '',
      transformedOutput: record.transformedOutput || ''
    }
    if(this.state.sourceDataFormat)
      this.state.transformedOutput = moment(this.state.sampleInput, this.state.sourceDataFormat, true).format(this.state.targetDataFormat)

    this.onChange = key => value => {
      if(typeof value === 'object') value = value.target.value
      let transformedOutput = this.state.transformedOutput
      if(key === 'sampleInput' && /date|time/i.test(this.state.sourceDataType)) {
        transformedOutput = moment(value, this.state.sourceDataFormat, true).format(this.state.targetDataFormat)
      }
      this.setState({ [key]: value, transformedOutput })
    }
  }

  render() {
    const formItemLayout = {
      labelCol: { xs: { span: 4 } },
      wrapperCol: { xs: { span: 8 } },
    }
    const validColor = '#00aa00'
    const invalidColor = '#ff0000'

    return (
      <div>
        <h2>Transform Editor</h2>
        <Form>
          <Form.Item
            {...formItemLayout}
            label={<b>SOURCE FIELD</b>}>
            <Select onChange={this.onChange('sourceField')} value={this.state.sourceField}>
              <Option value="">(none)</Option>
              <Option value="date">date</Option>
              <Option value="dob">dob</Option>
              <Option value="race">race</Option>
              <Option value="citation">citation</Option>
              <Option value="search">search</Option>
              <Option value="search_results">search_results</Option>
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Source Data Type">
            <Select onChange={this.onChange('sourceDataType')} value={this.state.sourceDataType}>
              <Option value="">(none)</Option>
              <Option value="dateTime">Date + time</Option>
              <Option value="date">Date</Option>
              <Option value="time">Time</Option>
              <Option value="string">String</Option>
              <Option value="char">Character</Option>
              <Option value="number">Number</Option>
              <Option value="boolean">Y/N</Option>
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Source Data Format">
            <Select onChange={this.onChange('sourceDataFormat')} value={this.state.sourceDataFormat}>
              <Option value="">(none)</Option>
              <Option value="YYYY-MM-DD">YYYY-MM-DD</Option>
              <Option value="MM/DD/YY">MM/DD/YY</Option>
              <Option value="DD/MM/YY">DD/MM/YY</Option>
              <Option value="MMM DD, YYYY">MMM DD, YYYY</Option>
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label={<b>TARGET FIELD (NIEM)</b>}>
            <Select onChange={this.onChange('targetField')} value={this.state.targetField}>
              <Option value="agency_name">agency_name</Option>
              <Option value="stop_date">stop_date</Option>
              <Option value="stop_time">stop_time</Option>
              <Option value="race_of_individual_stopped">race_of_individual_stopped</Option>
              <Option value="age_of_individual_stopped">age_of_individual_stopped</Option>
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Transformation active on">
            <DatePicker />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Transformation ends on">
            <DatePicker />
          </Form.Item>
        </Form>
        <hr />
        <Form style={{ marginTop: '2vh' }}>
          <Form.Item
            {...formItemLayout}
            label="Sample Input">
            <Input onChange={this.onChange('sampleInput')} value={this.state.sampleInput} />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Transformed Output">
            <Input disabled value={this.state.transformedOutput} />
            <div style={{ paddingTop: '1vh' }}>
              {/\binvalid\b/i.test(this.state.transformedOutput)
                ? <span style={{ fontSize: '2rem', color: invalidColor }}><Icon size="lg" name="exclamation-circle" style={{ color: invalidColor }} /> Invalid</span>
                : <span style={{ fontSize: '2rem', color: validColor }}><Icon size="lg" name="check-circle" style={{ color: validColor }} /> Valid</span>
              }
            </div>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

export default TransformEditor



// WEBPACK FOOTER //
// ./src/TransformEditor.js